// src/shared/constants/iconList.ts

// List of all available icons from your icon library (only icons with valid Material Icon mappings)
export const AVAILABLE_ICONS = [
    // Dashboard & Navigation
    'dashboard',
    'home',
    'menu',

    // Actions & Tools
    'settings',
    'edit',
    'delete',
    'add',
    'close',
    'check',
    'save',
    'refresh',
    'search',
    'filter_list',

    // UI Elements
    'palette',

    // Media & Audio
    'headphones',
    'music_note',
    'volume_up',
    'mic',
    'mic_off',
    'album',

    // Communication
    'chat',
    'email',
    'notifications',
    'comment',
    'phone',

    // Users & Accounts
    'person',
    'group',
    'people',
    'admin_panel_settings',

    // Emotions & Moods
    'mood',
    'emoji_emotions',

    // Files & Documents
    'folder',
    'insert_drive_file',
    'description',

    // Data & Analytics
    'bar_chart',
    'trending_up',

    // Development
    'code',
    'bug_report',

    // Status & Alerts
    'info',
    'warning',
    'error',

    // Arrows & Direction
    'arrow_upward',
    'arrow_downward',
    'arrow_back',
    'arrow_forward',
    'expand_less',
    'expand_more',
    'chevron_left',
    'chevron_right',

    // Common Actions
    'add_circle',
    'star',
    'favorite',
    'share',
    'download',
    'upload',
    'print',
    'lock',
    'lock_open',
    'visibility',
    'visibility_off',
    'help',

    // Date & Time
    'calendar_today',
    'schedule',

    // Location
    'location_on',
    'link',

    // Media
    'image',
    'photo_camera',
    'videocam',
    'camera_alt',

    // Devices
    'phone_android',
    'computer',
    'laptop',

    // Business
    'work',
    'business',
    'school',
    'event',

    // Sports
    'sports_soccer',

    // Transportation
    'flight_takeoff',
    'directions_car',
    'directions_bus',

    // Food
    'restaurant',

    // Shopping
    'shopping_cart',
    'store',

    // Money
    'payment',
    'credit_card',
    'attach_money',

    // Cloud
    'cloud',
    'sync',

    // Lists
    'list',
    'apps',

    // Media Controls
    'play_arrow',
    'pause',
    'stop',

    // Books
    'menu_book',
    'bookmark',

    // Labels
    'label'
];

// Group icons by category
export const ICON_CATEGORIES = {
    Navigation: ['dashboard', 'home', 'menu'],
    Actions: ['settings', 'edit', 'delete', 'add', 'close', 'check', 'save', 'refresh', 'search', 'filter_list'],
    UI: ['palette'],
    Media: ['headphones', 'music_note', 'volume_up', 'mic', 'mic_off', 'album'],
    Communication: ['chat', 'email', 'notifications', 'comment', 'phone'],
    Users: ['person', 'group', 'people', 'admin_panel_settings'],
    Emotions: ['mood', 'emoji_emotions'],
    Files: ['folder', 'insert_drive_file', 'description'],
    Analytics: ['bar_chart', 'trending_up'],
    Development: ['code', 'bug_report'],
    Status: ['info', 'warning', 'error'],
    Arrows: ['arrow_upward', 'arrow_downward', 'arrow_back', 'arrow_forward', 'expand_less', 'expand_more', 'chevron_left', 'chevron_right'],
    Common: ['add_circle', 'star', 'favorite', 'share', 'download', 'upload', 'print', 'lock', 'lock_open', 'visibility', 'visibility_off', 'help'],
    DateTime: ['calendar_today', 'schedule'],
    Location: ['location_on', 'link'],
    MediaContent: ['image', 'photo_camera', 'videocam', 'camera_alt'],
    Devices: ['phone_android', 'computer', 'laptop'],
    Business: ['work', 'business', 'school', 'event'],
    Sports: ['sports_soccer'],
    Transportation: ['flight_takeoff', 'directions_car', 'directions_bus'],
    Food: ['restaurant'],
    Shopping: ['shopping_cart', 'store'],
    Money: ['payment', 'credit_card', 'attach_money'],
    Cloud: ['cloud', 'sync'],
    Lists: ['list', 'apps'],
    MediaControls: ['play_arrow', 'pause', 'stop'],
    Books: ['menu_book', 'bookmark'],
    Labels: ['label']
};

// Helper function to search icons
export const searchIcons = (searchTerm: string): string[] => {
    if (!searchTerm || searchTerm.trim() === '') return AVAILABLE_ICONS;
    const term = searchTerm.toLowerCase().trim();
    return AVAILABLE_ICONS.filter(icon =>
        icon.toLowerCase().includes(term)
    );
};

// Helper function to get icon category
export const getIconCategory = (iconName: string): string | null => {
    for (const [category, icons] of Object.entries(ICON_CATEGORIES)) {
        if (icons.includes(iconName)) {
            return category;
        }
    }
    return null;
};